// frontend/src/constants/productInfo.js
//
// Medicinteknisk produktinformation ("etikett") enligt MDR 2017/745.
// Produkten är klassad som KLASS I (regel 11, MDR bilaga VIII) -> CE-märkning
// UTAN anmält organs nummer. Källa: teknisk dokumentation FIL1-FIL8 (feb 2026).
//
// Detta är den ENDA källan för etikettdata - Login, Kugghjulet ("Om appen")
// och Guiden läser alla härifrån, så uppgifterna ska bara ändras på ETT ställe.
// Håll `version` i synk med package.json vid varje release.
//
// KVARSTÅENDE PLATSHÅLLARE (ännu ej tilldelade enligt FIL8, planerat Q2 2026):
// udiDi, basicUdiDi, srn. Fyll i så snart de registrerats i EUDAMED.

export const PRODUCT_INFO = {
  name: 'Aion Notes',
  productType: 'Programvara som medicinteknisk produkt (SaMD)',
  version: '2.2.2',
  versionDate: '2026-02-06',        // dokumentationens datum (FIL1–FIL8)
  riskClass: 'I',                   // MDR 2017/745, regel 11 (bilaga VIII)
  classificationRule: 'Regel 11 (MDR bilaga VIII)',

  manufacturer: {
    name: 'JAIW AB',
    orgNumber: '559518-7146',
    address: 'Längdhoppsvägen 11, 137 54 Tungelsta, Sverige',
    email: 'johan@aionnotes.se',
    phone: null,                    // ej angivet i dokumentationen
    website: null,                  // ej angivet i dokumentationen
  },

  // Unique Device Identification + Single Registration Number.
  // Ännu ej tilldelade (FIL8: planerat Q2 2026) - uppdatera när de finns.
  udiDi: 'Tilldelas (planerat Q2 2026)',
  basicUdiDi: 'Tilldelas (planerat Q2 2026)',
  srn: 'Tilldelas (planerat Q2 2026)',

  // Kort avsett ändamål (intended purpose) för etiketten.
  intendedPurpose:
    'Digitalt dokumentationsstöd avsett för legitimerade fysioterapeuter och ' +
    'psykologer. Systemet transkriberar patientsamtal och strukturerar ' +
    'journaltext enligt användardefinierade mallar för granskning, redigering ' +
    'och godkännande innan överföring till journalsystem. Produkten ställer ' +
    'inte diagnos, ger inga behandlingsrekommendationer och fattar inga ' +
    'kliniska beslut.',

  // Valfri länk till fullständig elektronisk bruksanvisning (eIFU).
  // null = bruksanvisningen visas i Guiden i appen.
  ifuUrl: null,
};
